import api from '../api'

export default {
    namespaced: true,

    actions: {
        getGameConfigure(store,params) {
            return api.post(`/pumping/getGameConfigure`, '获取游戏配置', params)
        },
        updateInsurance(store,value) {
            return api.post(`/pumping/updateInsurance/${value}`, '修改保险返利开关')
        },
        updateLimt(store,value) {
            return api.post(`/pumping/updateNumber/${value}`, '修改分发的数值')
        },
        updatePumpingModeApi(store,value) {
            return api.post(`/pumping/updatePumpingMode/${value}`, '修改抽水方式')
        },

    }
}